import { gql } from "@outschool/ui-apollo";

import SavedSearchFragment from "./SavedSearchFragment";

export default gql`
  query SavedSearchesQuery {
    currentUser {
      uid
      savedSearches {
        ...SavedSearchFragment
      }
    }
  }
  ${SavedSearchFragment}
`;
